import { useEffect, useSyncExternalStore } from 'react'
import { ensureSearchIndex, getSearchIndexSnapshot, subscribeSearchIndex } from '../lib/searchIndexStore'

/** The global search index, loading it (cache first, then Storage) on mount. */
export function useSearchIndex() {
  const { status, index } = useSyncExternalStore(subscribeSearchIndex, getSearchIndexSnapshot)
  useEffect(() => {
    void ensureSearchIndex()
  }, [])
  return { index, loading: !index && status !== 'error', error: !index && status === 'error' }
}
